import { Component, Vue } from "vue-property-decorator";
import { Layout } from "ant-design-vue";
import { getModule } from "vuex-module-decorators";
import { GLGlobal } from "commonui";
import AppSettings from "@/modules/app-settings";
import { AppSettingsModel } from "@/util/constants";

const { Footer } = Layout;

@Component({
	components: {
		FooterLayout: Footer
	}
})
export default class VcFooter extends Vue {
	private settingsModule = getModule(AppSettings) as AppSettings;

	openPrivacyPolicy() {
		window.open(`${GLGlobal.authorityUrl()}/Copyright/privacy-policy`);
	}
}
